export const isFileEntry = (
  item: FileSystemEntry,
): item is FileSystemFileEntry => item.isFile;

export const isDirectoryEntry = (
  item: FileSystemEntry,
): item is FileSystemDirectoryEntry => item.isDirectory;

export const readAllEntryList = (
  dirReader: FileSystemDirectoryReader,
): Promise<FileSystemEntry[]> => {
  const entryList: FileSystemEntry[] = [];

  return new Promise((resolve, reject) => {
    const readBatch = () => {
      dirReader.readEntries(batch => {
        if (batch.length === 0) {
          resolve(entryList);
        } else {
          entryList.push(...batch);
          readBatch();
        }
      }, reject);
    };

    readBatch();
  });
};

export const readEntryRecursive = async (
  itemList: DataTransferItemList,
): Promise<FileSystemFileEntry[]> => {
  const fileEntryList: FileSystemFileEntry[] = [];

  const traverseFileTree = async (
    entry: FileSystemEntry,
    path = '',
  ): Promise<void> => {
    if (isFileEntry(entry)) {
      fileEntryList.push(entry);
    } else if (isDirectoryEntry(entry)) {
      const dirReader = entry.createReader();
      const entryList = await readAllEntryList(dirReader);

      await Promise.all(
        entryList.map(childEntry =>
          traverseFileTree(childEntry, path + entry.name + '/'),
        ),
      );
    }
  };

  const promiseList = [];

  for (let i = 0; i < itemList.length; i++) {
    const item = itemList[i].webkitGetAsEntry();

    item && promiseList.push(traverseFileTree(item));
  }

  await Promise.all(promiseList);

  return fileEntryList;
};

export const getFileByEntry = (entry: FileSystemFileEntry) =>
  new Promise<File>((resolve, reject) => {
    entry.file(file => {
      resolve(file);
    }, reject);
  });
